<template>
	<div
		id="investor-management"
		:class="[!isWeb ? 'mobile-investor-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="investor-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<InvestorTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshInvestors="refreshInvestors"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_INVESTORS } from '@/store/modules/investorManagement/actions';
import TableFilter from '@/components/modules/Investor/InvestorManagement/TableFilter/TableFilter.vue';
import InvestorTable from '@/components/modules/Investor/InvestorManagement/Table/Table.vue';

export default {
	name: 'InvestorManagement',
	components: { TableFilter, InvestorTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshInvestors();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('investorManagement', {
			getInvestors: GET_ALL_INVESTORS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshInvestors();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshInvestors();
		},
		orderByHeader(param) {
			if (this?.headerSelected === param) {
				if (this.orderSelected === 'ASC') {
					this.orderSelected = 'DESC';
				} else {
					this.orderSelected = 'ASC';
				}
			} else {
				this.orderSelected = 'DESC';
			}
			this.headerSelected = param;
			this.refreshInvestors();
		},
		refreshInvestors() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getInvestors({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'InvestorManagement.scss';
</style>
